var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.952182 6.14443H8.60932C10.1764 6.14443 11.4659 4.87485 11.4659 3.28788C11.4659 1.70091 10.1764 0.451172 8.60932 0.451172C7.83567 0.451172 7.08186 0.768566 6.54625 1.34384C6.18919 1.72075 6.18919 2.3357 6.58593 2.69277C6.96283 3.04984 7.57779 3.04984 7.93485 2.65309C8.11339 2.47456 8.35143 2.35554 8.60932 2.35554C9.12508 2.35554 9.54166 2.77212 9.54166 3.28788C9.54166 3.80365 9.12508 4.22023 8.58948 4.22023H0.952182C0.41658 4.22023 0 4.65664 0 5.17241C0 5.68818 0.436417 6.14443 0.952182 6.14443Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.418 11.8574H0.952183C0.41658 11.8574 0 12.2938 0 12.8096C0 13.3254 0.436417 13.7618 0.952183 13.7618H12.4379C12.9536 13.7618 13.3702 14.1784 13.3702 14.6941C13.3702 15.2099 12.9536 15.6265 12.4379 15.6265C12.1602 15.6265 11.9023 15.5075 11.7237 15.3091C11.3865 14.9123 10.7716 14.8528 10.3748 15.2099C9.97808 15.5471 9.91857 16.1621 10.2756 16.5588C10.8112 17.1936 11.6047 17.5507 12.4379 17.5507C14.005 17.5507 15.2944 16.2811 15.2944 14.6941C15.2944 13.1072 14.005 11.8574 12.418 11.8574Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4928 3.24805C14.1836 3.24805 12.9735 4.0217 12.4379 5.23176C12.2197 5.70785 12.4379 6.28313 12.914 6.50134C13.3901 6.71955 13.9653 6.50134 14.1836 6.02525C14.4216 5.50948 14.9374 5.17225 15.4928 5.17225C16.2863 5.17225 16.9211 5.82687 16.9211 6.60052C16.9211 7.37417 16.2863 8.0288 15.4928 8.0288H0.952183C0.41658 8.0288 0 8.46521 0 8.98098C0 9.49674 0.436417 9.93316 0.952183 9.93316H15.4928C17.3377 9.93316 18.8453 8.42554 18.8453 6.58069C18.8453 4.73583 17.3377 3.24805 15.4928 3.24805Z",
    fill: "#1AD393"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedAir);
export default __webpack_public_path__ + "static/media/SelectedAir.64502ed979c16ca9e6a57791dcf8cff3.svg";
export { ForwardRef as ReactComponent };